var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.79 67.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M9.26 65.68v-32H1.5v-10h7.83v-9.41c0-7.49 5.06-12.59 12.54-12.67h7.3v9.94c-1.37.06-2.76.09-4.15.2A3.51 3.51 0 0 0 21.46 15c-.22 2.74-.06 8.53-.06 8.53h11.89c-1.32 3.35-2.46 6.38-3.73 9.35-.17.4-1 .68-1.55.7-2.12.08-6.7 0-6.7 0l-.13 32.08z",
    "data-name": "Layer 58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e0380573bef6aa09d3b27fc372f1bf88.svg";
export { ForwardRef as ReactComponent };